export default {
    path: 'share_sales',
    component: () => import(/* webpackChunkName: "common-list" */ '@/pages/salesManage/shareSales'),
    meta: {title:'销售端'},
}